import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Icon, makeStyles, createStyles, GridList, GridListTile } from '@material-ui/core';

interface IAccordionProps {
    messages: string
    title: string
}

const useStyles = makeStyles((theme) => createStyles({
    root: {
        width: '100%',
        background: theme.palette.secondary.light,
    },
    accordionSummary: {
        background: 'transparent',
    },
    gridList: {
        width: 674,
        height: '6.125rem'
    },
    textTypography: {
        position: 'relative',
        overflow: 'hidden',
        textAlign: 'left',
        paddingLeft: '0.875rem',
    },
    accordionDetails: {
        padding: '1rem',
        heightMax: '6.125rem',
    },
}));

export default function CustomAccordion({ messages, title }: IAccordionProps) {
    const classes = useStyles();

    function populateAccordion() {
        return (
            <GridList cellHeight={'auto'} className={classes.gridList} cols={1}>
                {messages.split('<br/>').map((message: string) => {
                    if (message) {
                        return (
                            <GridListTile key={message} cols={1}>
                                <Typography className={classes.textTypography} variant="body2">
                                    {`• ${message}`}
                                </Typography>
                            </GridListTile>
                        );
                    }
                })}
            </GridList>);
    }

    return (
        <Accordion 
            className={classes.root}
            elevation={0}>
            <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}
                aria-controls="expandir accordion"
                id="expandir-accordion">
                <Typography variant="body2" color='primary'>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {populateAccordion()}
            </AccordionDetails>

        </Accordion>
    );
}


